import { render, staticRenderFns } from "./classify-goods.vue?vue&type=template&id=4a77970a&scoped=true&"
import script from "./classify-goods.vue?vue&type=script&lang=js&"
export * from "./classify-goods.vue?vue&type=script&lang=js&"
import style0 from "./classify-goods.vue?vue&type=style&index=0&id=4a77970a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a77970a",
  null
  
)

export default component.exports